// CompanyList.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './CompanyList.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const CompanyList = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axios.get(`${url}/api/company`);
        setCompanies(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch companies');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this company?")) return;

    try {
      await axios.delete(`${url}/api/company/${id}`);
      setCompanies(companies.filter(company => company._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete company');
    }
  };

  if (loading) return <div className="loading">Loading companies...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="companies-container">
      <div className="header">
        <h2>Companies List</h2>
        <button 
          onClick={() => navigate('/AddCompany')}
          className="add-button"
        >
          <Plus size={16} /> Add Company
        </button>
      </div>

      <table className="companies-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Manager</th>
            <th>Contact</th>
            <th>Logo</th>
            <th>Seal</th>
            <th>Signature</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {companies.map(company => (
            <tr key={company._id}>
              <td>{company.companyname}</td>
              <td>{company.companytype}</td>
              <td>{company.currentmanager}</td>
              <td>{company.contact}</td>
              <td>
                {company.companylogo && <img src={`${url}/uploads/${company.companylogo}`} alt="logo" width="50" />}
              </td>
              <td>
                {company.companyseal && <img src={`${url}/uploads/${company.companyseal}`} alt="seal" width="50" />}
              </td>
              <td>
                {company.companysignature && <img src={`${url}/uploads/${company.companysignature}`} alt="signature" width="50" />}
              </td>
              <td className="actions">
                <button 
                  onClick={() => navigate(`/Company/edit/${company._id}`)}
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>
                <button 
                  onClick={() => handleDelete(company._id)}
                  className="delete-btn"
                >
                  <Trash2 size={14} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CompanyList;
